import { render, staticRenderFns } from "./textagreementmanage.vue?vue&type=template&id=fc27c212&scoped=true&"
import script from "./textagreementmanage.vue?vue&type=script&lang=js&"
export * from "./textagreementmanage.vue?vue&type=script&lang=js&"
import style0 from "./textagreementmanage.vue?vue&type=style&index=0&id=fc27c212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc27c212",
  null
  
)

export default component.exports